import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';

import {
	Container,
	Item,
	TooltipWrapper,
	Button,
} from './styles'

import { theme } from 'lib/styles';
import Tooltip from 'components/Tooltip';

const SortableItem = SortableElement(({ item, itemIndex, active, t, ...props }) =>
	<Item
		active={item.selected}
		theme={theme}
		onClick={() => {
			props.viewItemsToggleHandler(false);
			props.activeIndexHandler(active ? -1 : itemIndex)
		}}
	>
		{item.element}
		<TooltipWrapper active={active}>
			<Tooltip
				tooltip={t('controls/image/remove')}
				icon="trash"
				fill="rgba(208,2,27,0.7)"
				danger
				onClickHandler={e => {
					e.stopPropagation();
					if (window.confirm(t(props.removeConfirmText))) {
						props.saveHandler('remove');
					}
				}}
			/>
		</TooltipWrapper>
	</Item>
);

const SortableList = SortableContainer(({ items, activeIndex, ...props }) => (
	<Container>
		{items.map((item, index) => (
			<SortableItem
				key={item.id}
				index={index}
				active={activeIndex === index}
				item={item}
				itemIndex={index}
				{...props}
			/>
		))}
	</Container>
));

class ListSelectedItems extends React.PureComponent {
	render() {
		const props = this.props;
		const { t } = props;
		const showToggleGallery = typeof props.showButton !== 'undefined' ? props.showButton : (props.activeIndex === -1 && !props.viewItems);

		return (
			<React.Fragment>
				<SortableList
					axis={props.axis || 'xy'}
					lockAxis={props.lockAxis}
					helperClass="sortableHelper"
					lockToContainerEdges={true}
					items={props.items}
					activeIndex={props.activeIndex}
					shouldCancelStart={() => props.activeIndex !== -1 }
					removeConfirmText={props.removeConfirmText}
					onSortEnd={props.onSortEndHandler}
					saveHandler={props.saveHandler}
					viewItemsToggleHandler={props.viewItemsToggleHandler}
					activeIndexHandler={props.activeIndexHandler}
					t={t}
				/>
				{ showToggleGallery &&
					<Button onClick={() => props.viewItemsToggleHandler(true)}>{t(props.viewItemsText)}</Button>
				}
			</React.Fragment>
		)
	}
}

ListSelectedItems.propTypes = {
	t: PropTypes.func,
	viewItems: PropTypes.bool,
	activeIndex: PropTypes.number,
	items: PropTypes.array,
	removeConfirmText: PropTypes.string,
	viewItemsText: PropTypes.string,
	viewItemsToggleHandler: PropTypes.func,
	activeIndexHandler: PropTypes.func,
	onSortEndHandler: PropTypes.func,
	saveHandler: PropTypes.func,
}

export default translate('translations')(ListSelectedItems)
